document.addEventListener('DOMContentLoaded', () => {
  function wordRemover() {
    document.querySelectorAll('.jdgm-prev-badge__text').forEach((el) => {
      el.textContent = el.textContent.replace('beoordelingen', '').replace('reviews', '').replace('Bewertungen', '').trim();
    });
  }

  let collBtns = document.querySelectorAll('.collection-tabs button.tab-btn');

  if (collBtns.length > 0) {
    collBtns.forEach((btn) => {
      btn.addEventListener('click', async function (e) {
        e.preventDefault();

        if (this.classList.contains('active')) {
          return;
        }

        document.querySelector('.collection-loader')?.classList.remove('hidden');

        collBtns.forEach((btn) => btn.classList.remove('active'));
        this.classList.add('active');

        let collHandle = this.getAttribute('data-collection');
        let collTemplate = this.getAttribute('data-collection-template');

        const newUrl = `/collections/${collHandle}`;
        window.history.pushState({ path: newUrl }, '', newUrl);

        try {
          const sectionId = document.querySelector('.mainCollection').getAttribute('id');

          // SECTION RENDERING FETCH

          const response = await fetch(`/collections/${collHandle}?section_id=${sectionId}`);
          const htmlString = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlString, 'text/html');

          const currentContainer = document.querySelector('.collection-product-container');

          const newContainer = doc.querySelector('.collection-product-container');

          const currentHeader = document.querySelector('.collection_header');

          const newHeader = doc.querySelector('.collection_header');

          // Update products
          if (currentContainer && newContainer) {
            currentContainer.innerHTML = newContainer.innerHTML;

            wordRemover();
          }

          // Update header
          if (currentHeader && newHeader) {
            currentHeader.innerHTML = newHeader.innerHTML;
          }

          // 2. TEMPLATE FETCH

          const templateResponse = await fetch(`/collections/${collHandle}?view=${collTemplate}`);
          const templateHtml = await templateResponse.text();
          const templateDoc = parser.parseFromString(templateHtml, 'text/html');
          const currentMainContent = document.querySelector('#MainContent');
          const templateMainContent = templateDoc.querySelector('#MainContent');

          if (!currentMainContent || !templateMainContent) return;

          // Current live .main-coll-product
          const currentMainProduct = currentMainContent.querySelector('.main-coll-product');

          // Template .main-coll-product
          const templateMainProduct = templateMainContent.querySelector('.main-coll-product');

          if (!currentMainProduct || !templateMainProduct) return;

          // Remove ALL sections after current .main-coll-product

          let nextEl = currentMainProduct.nextElementSibling;

          while (nextEl) {
            const removeEl = nextEl;
            nextEl = nextEl.nextElementSibling;
            removeEl.remove();
          }

          // Append template sections AFTER .main-coll-product

          let templateSection = templateMainProduct.nextElementSibling;

          while (templateSection) {
            currentMainContent.appendChild(templateSection.cloneNode(true));

            templateSection = templateSection.nextElementSibling;
          }
          document.querySelector('.collection-loader')?.classList.add('hidden');
        } catch (err) {
          console.error('Section rendering failed:', err);

          document.querySelector('.collection-loader')?.classList.add('hidden');
        }
      });
    });
  }
  setTimeout(() => {
    wordRemover();
  }, 1000);
});
